import instance from "./ApiConfig"; 
export const baseApiCall = async (config: any) => {
  try {
    const response = await instance(config);

    if (response?.status >= 200 && response?.status < 300) {  
      return response?.data; 
    } else {
      // store.dispatch(setLoadingFalse());
      throw new Error(`Unexpected status code: ${response?.status}`);
    }
  } catch (e: any) {
    console.log('API error', e);
    const errorMessage = e?.response?.data?.message || "An error occurred while making the request.";
    console.log("errorMessage errorMessage",errorMessage)
    // throw new Error(errorMessage);
    throw errorMessage
  
  }
  finally{
  }
};
